import { usePumpPortalTrades } from "@/hooks/usePumpPortalTrades";
import { LaserstreamOrderBook } from "@/components/LaserstreamOrderBook";

export function ForeignTokenTape({ mint }: { mint: string }) {
  const { rows, state, error } = usePumpPortalTrades(mint, 100);
  
  return (
    <div className="h-full flex flex-col w-full">
      <div className="live-tape-head">Live tape <b>{rows.length}</b> · Foreign Token</div>
      <div className="flex-1 min-h-0 relative">
        <LaserstreamOrderBook rows={rows} state={state} error={error} yMcCap={false} hideHints={true} />
      </div>
    </div>
  );
}
